let mutations = {
  set_states (state, data) {
    state.states = data
  },
  set_boards (state, data) {
    state.boards = data
  },
  filter_boards (state, data) {
    if (data === 'All') {
      state.filteredBoards = state.boards
    } else {
      state.filteredBoards = state.boards.filter(board => board.state === state.selectedStateId || board.state === '37')
    }
  },
  set_state (state, data) {
    state.selectedStateId = data.id
    state.selectedState = data.name
    state.selectedServiceProvider = ''
  },
  set_board (state, data) {
    state.selectedServiceProvider = data.name
    state.selectedServiceProviderQuestion = data.question
    state.selectedBillFetch = data.billFetch
    state.selectedPartial = data.partial
    state.selectedBbps = data.bbps
  },
  set_page_message (state, data) {
    state.pageMessage = data
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/postpaid/mutations.js